import { createAsyncActionType } from './index';

export const GET_FAQ = createAsyncActionType('faq', 'GET_FAQ');
